import React, { useState } from 'react';

// ... mismo imports

function CalculoProductos() {
  const [producto, setProducto] = useState('');
  const [litros, setLitros] = useState('');
  const [largo, setLargo] = useState('');
  const [ancho, setAncho] = useState('');
  const [temporada, setTemporada] = useState('verano');
  const [resultado, setResultado] = useState('');

  const PROFUNDIDAD_FIJA = 1.5;

  const calcularLitrosDesdeMedidas = () => {
    const l = parseFloat(largo);
    const a = parseFloat(ancho);
    if (!isNaN(l) && !isNaN(a)) {
      return l * a * PROFUNDIDAD_FIJA * 1000;
    }
    return null;
  };

  const volumenCalculado = calcularLitrosDesdeMedidas();

  const handleSubmit = (e) => {
    e.preventDefault();

    const volumenManual = parseFloat(litros);
    const volumen = volumenManual || volumenCalculado;

    if (!producto || !volumen) {
      setResultado('Por favor complete todos los campos.');
      return;
    }

    let dosis = '';

    switch (producto) {
      case 'Alguicida (Nataclor)':
        dosis = `${((volumen / 1000) * 10).toFixed(0)} cc por semana`;
        break;
      case 'Clarificador (Nataclor)':
        dosis = `${((volumen / 1000) * 5).toFixed(0)} cc (dosis puntual)`;
        break;
      case 'Cloro instantaneo (Nataclor)':
      case 'Cloro granulado (Nataclor)':
        dosis = `${((volumen / 1000) * 2).toFixed(0)} gr ${temporada === 'verano' ? 'por día' : 'por semana'}`;
        break;
      case 'Natabio (Nataclor)':
        dosis = `${((volumen / 1000) * 25).toFixed(0)} cc ${temporada === 'verano' ? 'por mes. Recomendado combinar con 1/4 de dosis de cloro.' : 'cada 3 meses.'}`;
        break;
      case 'Pastillas multiaccion 200gr (Nataclor)':
        dosis = `${Math.ceil(volumen / 20000)} pastilla(s) ${temporada === 'verano' ? 'por semana' : 'por mes'}`;
        break;
      case 'Pastillas multiaccion 50gr (Nataclor)':
        dosis = `${Math.ceil(volumen / 5000)} pastilla(s) ${temporada === 'verano' ? 'por semana' : 'por mes'}`;
        break;

      // Productos Unyclor
      case 'Gel Clarificador (Unyclor)':
        dosis = `${((volumen / 1000) * (temporada === 'verano' ? 2 : 1)).toFixed(0)} cc (en skimmer o cesto de bomba)`;
        break;
      case 'Super alguicida (Unyclor)':
        dosis = `${((volumen / 1000) * (temporada === 'verano' ? 10 : 5)).toFixed(0)} cc (dosis puntual)`;
        break;
      case 'Unybio (Unyclor)':
        dosis = `${((volumen / 1000) * 25).toFixed(0)} cc por aplicación. En invierno rinde hasta 3 meses.`;
        break;
      case 'Unycel (Unyclor)':
        dosis = `${((volumen / 1000) * 33.33).toFixed(0)} cc por aplicación. En invierno rinde hasta 3 meses.`;
        break;
      case 'Alguicida (Unyclor)':
        dosis = `${((volumen / 1000) * 10).toFixed(0)} cc ${temporada === 'verano' ? 'por semana' : 'cada 2 semanas'}`;
        break;
      case 'Clarificador (Unyclor)':
        dosis = `${((volumen / 1000) * (temporada === 'verano' ? 4 : 2)).toFixed(0)} cc (dosis puntual)`;
        break;
      default:
        dosis = 'Producto no reconocido';
    }

    setResultado(`Dosis recomendada: ${dosis}`);
  };

  const desactivarMedidas = litros !== '';
  const desactivarLitros = largo !== '' || ancho !== '';

  return (<>
  <br/><br/><br/><br/><br/>
    <div className="container my-5">
      <h1 className="text-center mb-4">Calcula cuánto producto necesitas para tu pileta</h1>
      <div className="d-flex justify-content-center">
        <form className="w-100" onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor="producto" className="form-label">Seleccione un producto:</label>
            <select id="producto" className="form-control" value={producto} onChange={(e) => setProducto(e.target.value)} required>
              <option value="">Seleccione un producto</option>

              <optgroup label="Nataclor">
                <option>Alguicida (Nataclor)</option>
                <option>Clarificador (Nataclor)</option>
                <option>Cloro instantaneo (Nataclor)</option>
                <option>Cloro granulado (Nataclor)</option>
                <option>Natabio (Nataclor)</option>
                <option>Pastillas multiaccion 200gr (Nataclor)</option>
                <option>Pastillas multiaccion 50gr (Nataclor)</option>
              </optgroup>

              <optgroup label="Unyclor">
                <option>Gel Clarificador (Unyclor)</option>
                <option>Super alguicida (Unyclor)</option>
                <option>Unybio (Unyclor)</option>
                <option>Unycel (Unyclor)</option>
                <option>Alguicida (Unyclor)</option>
                <option>Clarificador (Unyclor)</option>
              </optgroup>
            </select>

          </div>

          <div className="mb-3">
            <label htmlFor="litros" className="form-label">Litros de la pileta:</label>
            <input
              type="number"
              id="litros"
              className="form-control"
              min="0"
              value={litros}
              onChange={(e) => {
                setLitros(e.target.value);
                setLargo('');
                setAncho('');
              }}
              disabled={desactivarLitros}
            />
          </div>

          <div className="mb-3">
            <label className="form-label">O ingresá las medidas de tu pileta (en metros):</label>
            <div className="row g-2">
              <div className="col">
                <input
                  type="number"
                  className="form-control"
                  placeholder="Largo"
                  value={largo}
                  onChange={(e) => {
                    setLargo(e.target.value);
                    setLitros('');
                  }}
                  disabled={desactivarMedidas}
                />
              </div>
              <div className="col">
                <input
                  type="number"
                  className="form-control"
                  placeholder="Ancho"
                  value={ancho}
                  onChange={(e) => {
                    setAncho(e.target.value);
                    setLitros('');
                  }}
                  disabled={desactivarMedidas}
                />
              </div>
            </div>
            <small className="text-muted">Se asume una profundidad promedio de <strong>1.5 m</strong>.</small>
          </div>

          {volumenCalculado && !litros && (
            <div className="mb-3 text-primary fw-bold">
              Volumen estimado: {volumenCalculado.toLocaleString()} litros
            </div>
          )}

          <div className="mb-3">
            <label htmlFor="temporada" className="form-label">Temporada:</label>
            <select id="temporada" className="form-control" value={temporada} onChange={(e) => setTemporada(e.target.value)} required>
              <option value="verano">Verano</option>
              <option value="invierno">Invierno</option>
            </select>
          </div>

          <button type="submit" className="btn btn-primary w-100">Calcular</button>
        </form>
      </div>

      {resultado && (
        <div className="alert alert-info mt-4 text-center">{resultado}</div>
      )}
    </div>
    </>
  );
}

export default CalculoProductos;
